// // // src/components/CtaSection.js

// // import React, { useState } from 'react';
// // import './CtaSection.css'; // Import the CSS for the styling
// // import { useLocation } from 'react-router-dom';
// // import axios from 'axios';

// // const CtaSection = () => {

// //   const location = useLocation();

// //   let sectionMargin = '0px'
// //   if (location.pathname === '/demo') {
// //     sectionMargin = '90px';
// //   }

// //   // form state for handling input values
// //   const [formData, setFormData] = useState({
// //     firstName: '',
// //     lastName: '',
// //     email: '',
// //     phone: '',
// //     message: '',
// //   });

// //   const [errors, setErrors] = useState({});

// //   // validate function
// //   const validate = (field, value) => {
// //     const newErrors = { ...errors };
// //     const namePattern = /^[A-Za-z\s]+$/;
// //     const phonePattern = /^[0-9]+$/;
// //     const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;


// //     if (field === 'firstName' || field === 'lastName') {
// //       if (!namePattern.test(value)) {
// //         newErrors.name = 'Name must contain only alphabets';
// //       } else {
// //         delete newErrors.name;
// //       }
// //     }

// //     if (field === 'phone') {
// //       if (!phonePattern.test(value)) {
// //         newErrors.phone = 'Phone number must contain only numbers';
// //       } else {
// //         delete newErrors.phone;
// //       }
// //     }

// //     if (field === 'email') {
// //       if (!emailPattern.test(value)) {
// //         newErrors.email = 'Please enter a valid email address';
// //       } else {
// //         delete newErrors.email;
// //       }
// //     }

// //     setErrors(newErrors);
// //   };


// //   // handle form submit
// //   const handleSubmit = (e) => {
// //     e.preventDefault();

// //     const newErrors = {};

// //     // Validate all fields on submit
// //     validate('firstName', formData.firstName);
// //     validate('lastName', formData.lastName);
// //     validate('email', formData.email);
// //     validate('phone', formData.phone);
// //     // validata('message',formData.message)

// //     if (Object.keys(newErrors).length === 0) {
// //       // If no errors, form can be submitted
// //       console.log('Form Submitted', formData);
// //     } else {
// //       setErrors(newErrors);
// //     }
// //   };

// //   // handle input change
// //   const handleInputChange = (e) => {
// //     const { name, value } = e.target;
// //     setFormData({ ...formData, [name]: value });

// //     // Validate input as user types
// //     validate(name, value);
// //   };

// //   try
// //   {
// //     const response = await axios.post(
// //         "http://localhost:8000/api/v1/demo",
// //         {
// //           First_Name: formData.firstName,
// //           Last_Name: formData.lastName,
// //           Phone_Number: formData.number,
// //           Email_Address: formData.email,
// //           Message: formData.password
// //         })

// //         if (response.data.success) {
// //         setMessageInfo({ type: "success", message: "Demo booked successfully!" });
// //         // Reset form
// //         setFormData({
// //           First_Name: "",
// //           Last_Name: "",
// //           Phone_Number: "",
// //           Email_Address: "",
// //           Message:""
// //         });
// //       }
// //       else 
// //       {
// //         setMessageInfo({ type: "error", message: response.data.message || "Something went wrong." });
// //       }
// //   }
// //   catch(err)
// //   {
// //     {
// //       console.error("Error submitting form:", error);

// //       let errorMessage = "Failed to Book.";
      
// //       if (error.response && error.response.data && error.response.data.message) 
// //       {
// //           errorMessage = error.response.data.message;
// //       } 
// //       else if (error.message) 
// //       {
// //           errorMessage = error.message;
// //       }

// //       setMessageInfo({ type: "error", message: errorMessage });
// //     }
// //   }


// //   return (
// //     <section id="ctaSection" className="cta-section" style={{ marginTop: sectionMargin }}>
// //       <div className="cta-container">
// //         <div className="cta-content">
// //           <h2 className="cta-title">Ready to explore Doclivo's complete operating system?</h2>
// //           <p className="cta-description">
// //             Fill out the form and we'll get in touch with you as soon as possible.
// //           </p>
// //           <div className="cta-contact">
// //             <div className="cta-contact-item">
// //               <a href="tel:078 6439 0024">
// //                 <span className="cta-contact-icon">
// //                   <i className="fas fa-phone"></i> {/* Assuming FontAwesome is being used */}
// //                 </span>
// //                 <span className="cta-contact-info">+91 738 789 3638</span>
// //               </a>
// //             </div>
// //             <div className="cta-contact-item">
// //               <a href="mailto:doclivo@example.com">
// //                 <span className="cta-contact-icon">
// //                   <i className="fas fa-envelope"></i> {/* FontAwesome Envelope Icon */}
// //                 </span>
// //                 <span className="cta-contact-info">info@doclivo.com</span>
// //               </a>
// //             </div>
// //           </div>
// //         </div>

// //         {/* Form Section */}
// //         <div className="cta-form">
// //           <form onSubmit={handleSubmit}>
// //             <div className="form-group">
// //               <input
// //                 type="text"
// //                 name="firstName"
// //                 placeholder="First Name *"
// //                 value={formData.firstName}
// //                 onChange={handleInputChange}
// //                 required
// //               />
// //               <input
// //                 type="text"
// //                 name="lastName"
// //                 placeholder="Last Name *"
// //                 value={formData.lastName}
// //                 onChange={handleInputChange}
// //                 required
// //               />
// //             </div>
// //             {errors.name && <p className="error" style={{color: "red"}}>{errors.name}</p>}
// //             <div className="form-group">
// //               <input
// //                 type="email"
// //                 name="email"
// //                 placeholder="Email Address *"
// //                 value={formData.email}
// //                 onChange={handleInputChange}
// //                 required
// //               />
// //               <input
// //                 type="tel"
// //                 name="phone"
// //                 placeholder="Phone Number *"
// //                 value={formData.phone}
// //                 onChange={handleInputChange}
// //                 required
// //               />
// //             </div>
// //             {errors.email && <p className='error' style={{color: "red"}}>{errors.email}</p>}
// //             {errors.phone && <p className='error' style={{color: "red"}}>{errors.phone}</p>}
// //             <div className="form-group">
// //               <textarea
// //                 name="message"
// //                 placeholder="Your Message"
// //                 rows="5"
// //                 value={formData.message}
// //                 onChange={handleInputChange}
// //               ></textarea>
// //             </div>
// //             <div className="cta-button-container">
// //               <button type="submit" className="cta-button">Book A Demo</button>
// //             </div>
// //           </form>
// //         </div>
// //       </div>
// //     </section>
// //   );
// // };

// // export default CtaSection;



// // src/components/CtaSection.js
// import React, { useState } from 'react';
// import { useLocation } from 'react-router-dom';
// import axios from 'axios';
// import './CtaSection.css';
// import { fireEvent } from '@testing-library/react';



// const CtaSection = () => {
//   const location = useLocation();
//   const sectionMargin = location.pathname === '/demo' ? '90px' : '0px';

//   let ErrorCount;

//   const [formData, setFormData] = useState({
//     firstName: '',
//     lastName: '',
//     email: '',
//     phone: '',
//     message: '',
//   });

//   const [errors, setErrors] = useState({});
//   const [messageInfo, setMessageInfo] = useState({ type: '', message: '' });

//   const validate = (field, value) => {
//     const newErrors = { ...errors };
//     const namePattern = /^[A-Za-z\s]+$/;
//     const phonePattern = /^[0-9]+$/;
//     const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

//     if (field === 'firstName' && !namePattern.test(value)) {
//       newErrors.firstName = 'First Name must contain only alphabets';
//     } 
//     else if (field === 'firstName') {
//       delete newErrors.firstName;
//     }

//     if (field === 'lastName' && !namePattern.test(value)) {
//       newErrors.lastName = 'Last Name must contain only alphabets';
//     } 
//     else if (field === 'lastName') {      
//       delete newErrors.lastName;
//     }

//     if (field === 'phone' && !phonePattern.test(value)) {
//       newErrors.phone = 'Phone number must contain only numbers';
//     } else if (field === 'phone') {
//       delete newErrors.phone;
//     }

//     if (field === 'email' && !emailPattern.test(value)) {
//       newErrors.email = 'Please enter a valid email address';
//     } else if (field === 'email') {
//       delete newErrors.email;
//     }

//     // if (field === 'message' && value.trim().length < 5) {
//     //   newErrors.message = 'Message must be at least 5 characters long';
//     // } else if (field === 'message') {
//     //   delete newErrors.message;
//     // }

//     ErrorCount = newErrors;
//     setErrors(newErrors);
//   };

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setFormData({ ...formData, [name]: value });
//     validate(name, value);
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     // final validation
//     Object.keys(formData).forEach((key) => validate(key, formData[key]));

//     if (Object.keys(errors).length > 0) {
//       return;
//     }

//     try {
      
//       // alert(errors);
//       const response = await axios.post("http://localhost:8000/api/v1/demo", {
//         First_Name: formData.firstName,
//         Last_Name: formData.lastName,
//         Phone_Number: formData.phone,
//         Email_Address: formData.email,
//         Message: formData.message,
//       });

//       if (response.data.success) {
//         setMessageInfo({ type: "success", message: "Demo booked successfully!" });
//         // Reset form
//         setFormData({
//           firstName: '',
//           lastName: '',
//           email: '',
//           phone: '',
//           message: '',
//         });
//         setTimeout(() => {
//           setMessageInfo("");
//         }, 4000);
//       }
//      else 
//       {
//         setMessageInfo({ type: "error", message: response.data.message || "Something went wrong." });
        
//       }
//     } 
//     catch (error) 
//     {
//       let errorMessage;
//     //   console.error("Error submitting form:", error);
//     //   if (error.status === 500){
//     //      errorMessage = "email already exists";
//     //   }
//     //   else
//     //   {
//     //      errorMessage = error.response?.data?.message || error.message || "Failed to book demo.";
//     //   }   
//       setMessageInfo({ type: "error", message: errorMessage });
//       // setTimeout(() => {
//       //     setMessageInfo("");
//       //   }, 4000);
//     }

//   };

//   return (
//     <section id="ctaSection" className="cta-section" style={{ marginTop: sectionMargin }}>
//       <div className="cta-container">
//         <div className="cta-content">
//           <h2 className="cta-title">Ready to explore Doclivo's complete operating system?</h2>
//           <p className="cta-description">
//             Fill out the form and we'll get in touch with you as soon as possible.
//           </p>
//           <div className="cta-contact">
//             <div className="cta-contact-item">
//               <a href="tel:+917387893638">
//                 <span className="cta-contact-icon"><i className="fas fa-phone"></i></span>
//                 <span className="cta-contact-info">+91 738 789 3638</span>
//               </a>
//             </div>
//             <div className="cta-contact-item">
//               <a href="mailto:info@doclivo.com">
//                 <span className="cta-contact-icon"><i className="fas fa-envelope"></i></span>
//                 <span className="cta-contact-info">info@doclivo.com</span>
//               </a>
//             </div>
//           </div>
//         </div>

//         {/* Form Section */}
//         <div className="cta-form">
//           <form onSubmit={handleSubmit}>
//             <div className="form-group">
//               <input type="text" name="firstName" placeholder="First Name *" value={formData.firstName} onChange={handleInputChange} required />
//               <input type="text" name="lastName" placeholder="Last Name *" value={formData.lastName} onChange={handleInputChange} required />
//             </div> 
//             {errors.firstName && <p className="error">{errors.firstName}</p>}
//             {errors.lastName && <p className="error">{errors.lastName}</p>}
//             <div className="form-group">
//               <input type="email" name="email" placeholder="Email Address *" value={formData.email} onChange={handleInputChange} required />
//               <input type="tel" name="phone" placeholder="Phone Number *" value={formData.phone} onChange={handleInputChange} required />
//             </div>
//             {errors.email && <p className="error">{errors.email}</p>}
//             {errors.phone && <p className="error">{errors.phone}</p>}
//             <div className="form-group">
//               <textarea name="message" placeholder="Your Message" rows="5" value={formData.message} onChange={handleInputChange}></textarea>
//             </div>
//             {errors.message && <p className="error">{errors.message}</p>}
//             {messageInfo.message && (
//               <p style={{ color: messageInfo.type === 'error' ? 'red' : 'green' }}>
//                 {messageInfo.message}
//               </p>
//             )}
//             <div className="cta-button-container">
//               <button type="submit" className="cta-button">Book A Demo</button>
//             </div>
//           </form>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default CtaSection;


// src/components/CtaSection.js
import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import './CtaSection.css';

const CtaSection = () => {
  const location = useLocation();
  const sectionMargin = location.pathname === '/demo' ? '90px' : '0px';

  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    message: '',
  });

  const [errors, setErrors] = useState({});
  const [messageInfo, setMessageInfo] = useState({ type: '', message: '' });

  // Validation function
  const validateField = (field, value) => {
    let error = '';
    const namePattern = /^[A-Za-z\s]+$/;
    const phonePattern = /^[0-9]{10}$/; // exactly 10 digits
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    switch (field) {
      case 'firstName':
        if (!namePattern.test(value)) error = 'First Name must contain only alphabets';
        break;
      case 'lastName':
        if (!namePattern.test(value)) error = 'Last Name must contain only alphabets';
        break;
      case 'phone':
        if (!phonePattern.test(value)) error = 'Phone number must be exactly 10 digits';
        break;
      case 'email':
        if (!emailPattern.test(value)) error = 'Please enter a valid email address';
        break;
      case 'message':
        if (value.trim().length < 5) error = 'Message must be at least 5 characters long';
        break;
      default:
        break;
    }

    return error;
  };

  // Handle input change
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });

    // Real-time validation
    setErrors({ ...errors, [name]: validateField(name, value) });
  };

  // Handle form submit
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Final validation before submit
    const newErrors = {};
    Object.keys(formData).forEach((key) => {
      const error = validateField(key, formData[key]);
      if (error) newErrors[key] = error;
    });

    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) return; // stop if validation fails

    try {
      const response = await axios.post('http://localhost:8000/api/v1/demo', {
        First_Name: formData.firstName.trim(),
        Last_Name: formData.lastName.trim(),
        Phone_Number: formData.phone.trim(),
        Email_Address: formData.email.trim(),
        Message: formData.message.trim(),
      });

      if (response.data.success) {
        setMessageInfo({ type: 'success', message: 'Demo booked successfully!' });
        setFormData({ firstName: '', lastName: '', email: '', phone: '', message: '' });
      } else {
        setMessageInfo({ type: 'error', message: response.data.message || 'Something went wrong.' });
      }

    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message || 'Failed to book demo.';
      setMessageInfo({ type: 'error', message: errorMessage });
    }

    // Clear message after 4 seconds
    setTimeout(() => setMessageInfo({ type: '', message: '' }), 4000);
  };

  return (
    <section id="ctaSection" className="cta-section" style={{ marginTop: sectionMargin }}>
      <div className="cta-container">
        <div className="cta-content">
          <h2 className="cta-title">Ready to explore Doclivo's complete operating system?</h2>
          <p className="cta-description">
            Fill out the form and we'll get in touch with you as soon as possible.
          </p>
          <div className="cta-contact">
            <div className="cta-contact-item">
              <a href="tel:+917387893638">
                <span className="cta-contact-icon"><i className="fas fa-phone"></i></span>
                <span className="cta-contact-info">+91 738 789 3638</span>
              </a>
            </div>
            <div className="cta-contact-item">
              <a href="mailto:info@doclivo.com">
                <span className="cta-contact-icon"><i className="fas fa-envelope"></i></span>
                <span className="cta-contact-info">info@doclivo.com</span>
              </a>
            </div>
          </div>
        </div>

        <div className="cta-form">
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <input type="text" name="firstName" placeholder="First Name *" value={formData.firstName} onChange={handleInputChange} required />
              <input type="text" name="lastName" placeholder="Last Name *" value={formData.lastName} onChange={handleInputChange} required />
            </div>
            {errors.firstName && <p className="error">{errors.firstName}</p>}
            {errors.lastName && <p className="error">{errors.lastName}</p>}

            <div className="form-group">
              <input type="email" name="email" placeholder="Email Address *" value={formData.email} onChange={handleInputChange} required />
              <input type="tel" name="phone" placeholder="Phone Number *" value={formData.phone} onChange={handleInputChange} required />
            </div>
            {errors.email && <p className="error">{errors.email}</p>}
            {errors.phone && <p className="error">{errors.phone}</p>}

            <div className="form-group">
              <textarea name="message" placeholder="Your Message" rows="5" value={formData.message} onChange={handleInputChange}></textarea>
            </div>
            {errors.message && <p className="error">{errors.message}</p>}

            {messageInfo.message && (
              <p style={{ color: messageInfo.type === 'error' ? 'red' : 'green' }}>
                {messageInfo.message}
              </p>
            )}

            <div className="cta-button-container">
              <button type="submit" className="cta-button">Book A Demo</button>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
};

export default CtaSection;
